import * as React from "react";
import type { InputCurrencyProps } from "./InputCurrencyProps";
import { Input } from "@/components/ui/Input";
import { clsx } from "clsx";
import classes from "./InputCurrency.module.scss";

export const InputCurrency = (props: InputCurrencyProps) => {
  const {
    currencySymbol = "£",
    className,
    onPaste,
    onChange,
    onKeyDown,
    ...inputProps
  } = props;

  const handleChangeValue = (value: string) => {
    const sanitized = value.replace(/[^0-9.-]/g, "");
    onChange?.(sanitized);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    onPaste?.(e);
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text");
    handleChangeValue(pastedText);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleChangeValue(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    onKeyDown?.(e);

    if (e.ctrlKey || e.metaKey) return;

    const controlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Home",
      "End",
    ];

    if (controlKeys.includes(e.key)) return;

    const allowed = /[0-9.]/;

    if (!allowed.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <label className={clsx(classes.inputCurrency, className)}>
      <span className={classes.inputCurrency__prefix}>{currencySymbol}</span>
      <div className={classes.inputCurrency__input}>
        <Input
          type="number"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          {...inputProps}
        />
      </div>
    </label>
  );
};
